import styled from 'styled-components'

export const AlarmSettingsCardsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 45%;
    padding: 16px 24px;
    border: 1px solid ${({ theme }) => theme['gray-300']};
    justify-content: space-around;

    .button {
        width: 160px;
        height: 34px;
    }

    .label-title {
        font-weight: 600;
        font-size: 14px;
    }

    .label-text {
        font-weight: 400;
        font-size: 14px;
    }
`
